import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.884 19.13h12.291a.947.947 0 0 0 .961-.95.957.957 0 0 0-.961-.96H5.885a.947.947 0 0 0-.95.96c0 .534.416.95.95.95M3.452 13.02H20.62c.534 0 .949-.415.949-.95a.947.947 0 0 0-.95-.96H3.453a.957.957 0 0 0-.96.96c0 .535.426.95.96.95M.95 6.91h22.1c.535 0 .95-.415.95-.949A.947.947 0 0 0 23.05 5H.95a.947.947 0 0 0-.95.961c0 .534.415.949.95.949"
    }, null, -1)
  ])))
}
export default { render: render }